<div class="grid-1">
  @if (this.invoices.length > 0) {
    @if (this.invoices.length > 1) {
      <app-dropdown
        type="regular"
        [items]="getUniqueInvoiceYears"
        icon="file-lines"
        [(selected)]="this.selectedYear"
        ariaLabel="Kies factuur jaar"
        />
    }
    @for (month of this.getMonthsOfSelectedYear(); track month) {
      <div class="no-padding grid-desktop-2 grid-tablet-1 grid-mobile-1 root-container">
        <h2 class="title">{{ month | monthname }}, {{ selectedYear }}</h2>
        @for (invoice of this.getInvoicesByYearAndMonth(month); track invoice) {
          <app-card header="{{invoice.invoice_number}}" class="invoice-card">
            <app-badge ngProjectAs="[badge]" icon="file-lines" size="small"/>
            <div class="info-list grid-desktop-2 grid-tablet-2 grid-mobile-2 no-padding">
              <div>Factuurdatum:</div>
              <div>{{ invoice.invoice_date | date:"dd-MM-yyyy" }}</div>
              <div>Bedrag:</div>
              <div>
                <app-currency [value]="invoice.amount_incl || 0"/>
              </div>
              <div>Status:</div>
              <div>
                <app-payment-status [isPaid]="invoice.is_paid"/>
              </div>
            </div>
            <app-button
              ngProjectAs="[button]"
              type="primary"
              (click)="this.download(invoice)">
              Downloaden
            </app-button>
            <app-button
              ngProjectAs="[button]"
              type="outline"
              (click)="this.showInvoice(invoice)">
              Bekijken
            </app-button>
          </app-card>
        }
      </div>
    }
  } @else {
    <app-not-found header="Geen facturen gevonden">
      <span>Binnenkort verschijnt hier je eerste factuur.</span>
    </app-not-found>
  }
</div>
